import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { DownloadIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
export function FinalCTASection() {
  const ref = useScrollReveal();
  return <section ref={ref} id="final-cta" className="w-full section-padding" style={{
    backgroundColor: '#1a2744'
  }} aria-label="Final offer and call to action" data-id="element-16">
      {/* Star decorations */}
      <div className="absolute pointer-events-none inset-0 overflow-hidden" aria-hidden="true" data-id="element-17">
        <span className="absolute top-8 left-12 text-yellow-200 opacity-15 text-xs" data-id="element-18">
          ✦
        </span>
        <span className="absolute top-20 right-16 text-yellow-200 opacity-10 text-sm" data-id="element-19">
          ✦
        </span>
        <span className="absolute bottom-16 left-1/4 text-yellow-200 opacity-10 text-[8px]" data-id="element-20">
          ✦
        </span>
        <span className="absolute bottom-8 right-8 text-yellow-200 opacity-20 text-xs" data-id="element-21">
          ✦
        </span>
      </div>

      <div className="max-w-2xl mx-auto text-center relative" data-id="element-22">
        {/* Moon */}
        <div className="scroll-reveal mb-6" data-id="element-23">
          <span className="text-5xl" aria-hidden="true" data-id="element-24">
            🌙
          </span>
        </div>

        {/* Heading */}
        <div className="scroll-reveal scroll-reveal-delay-1 mb-4" data-id="element-25">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-26">
            No More 3 AM Kitchen Floor Breakdowns.
          </h2>
        </div>

        {/* Sub-heading */}
        <div className="scroll-reveal scroll-reveal-delay-2 mb-8" data-id="element-27">
          <p className="text-lg md:text-xl leading-relaxed" style={{
          color: '#d4cfc8',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-28">
            No more dreading bedtime. Just a rested child — and a regained life.
          </p>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-10" data-id="element-29" />

        {/* Price block */}
        <div className="scroll-reveal scroll-reveal-delay-3 rounded-2xl p-8 md:p-10 mb-8" style={{
        backgroundColor: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(201,169,110,0.3)'
      }} data-id="element-30">
          <p className="text-sm font-medium mb-2 uppercase tracking-widest" style={{
          color: '#a09890',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-31">
            Get the Full Reset
          </p>
          <div className="flex items-center justify-center gap-3 mb-2 flex-wrap" data-id="element-32">
            <span className="text-xl line-through" style={{
            color: '#a09890',
            fontFamily: "'Inter', sans-serif"
          }} aria-label="Original price $19.99" data-id="element-33">
              $19.99
            </span>
            <span className="text-6xl md:text-7xl font-black" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#c9a96e'
          }} data-id="element-34">
              $6.36
            </span>
            <span className="inline-block px-2.5 py-1 rounded-full text-xs font-bold tracking-wide" style={{
            backgroundColor: 'rgba(201,169,110,0.2)',
            color: '#c9a96e',
            border: '1px solid rgba(201,169,110,0.5)',
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-35">
              68% OFF
            </span>
          </div>
          <p className="text-sm mb-8" style={{
          color: '#a09890',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-36">
            One-time payment. Instant access. No subscription.
          </p>

          {/* CTA Button */}
          <button className="animate-pulse-gold w-full flex flex-col items-center justify-center px-8 py-5 rounded-xl font-bold text-xl transition-transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-yellow-400 focus:ring-offset-2 mb-4" style={{
          backgroundColor: '#c9a96e',
          color: '#1a2744',
          fontFamily: "'Inter', sans-serif"
        }} aria-label="Get the 3-Night No-Cry Sleep Reset for $6.36 — instant PDF download" onClick={() => {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'AddToCart', {
              value: 6.36,
              currency: 'USD',
              content_name: 'The 3-Night No-Cry Sleep Reset',
              content_type: 'product'
            });
          }
          window.location.href = 'https://www.calmnestguides.com/cart/44046521794646:1';
        }} data-id="element-37">
            <span className="flex items-center gap-2" data-id="element-38">
              <DownloadIcon className="w-5 h-5" aria-hidden="true" data-id="element-39" />
              GET THE RESET FOR $6.36
            </span>
            <span className="text-sm font-normal mt-1 opacity-75" data-id="element-40">
              Instant PDF Download • Start Your 72-Hour Reset Tonight
            </span>
          </button>

          {/* Trust signals */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-xs" style={{
          color: '#a09890',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-41">
            <span className="flex items-center gap-1.5" data-id="element-42">
              <LockIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-43" />
              Secure Checkout
            </span>
            <span className="hidden sm:block opacity-30" data-id="element-44">•</span>
            <span className="flex items-center gap-1.5" data-id="element-45">
              <ShieldCheckIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-46" />
              Pediatric Sleep Science Based
            </span>
            <span className="hidden sm:block opacity-30" data-id="element-47">•</span>
            <span className="flex items-center gap-1.5" data-id="element-48">
              <DownloadIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-49" />
              Instant PDF Access
            </span>
          </div>
        </div>

        {/* Final reassurance */}
        <div className="scroll-reveal scroll-reveal-delay-4" data-id="element-50">
          <p className="text-sm italic" style={{
          color: '#a09890',
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-51">
            "Because every parent deserves to sleep through the night."
          </p>
        </div>
      </div>
    </section>;
}